import { MoreHorizontal } from 'lucide-react';
import { useIntl } from '@/core/i18n/use-intl';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from '@/shared/components/ui';

interface UserTableActionsProps {
  onEdit: () => void;
  onDelete: () => void;
  onResend: () => void;
  onArchive: () => void;
  onUnarchive: () => void;
  isInvite?: boolean;
  isArchived?: boolean;
  disabled?: boolean;
}

export const UserTableActions = ({
  onEdit,
  onDelete,
  onResend,
  onArchive,
  onUnarchive,
  isInvite,
  isArchived,
  disabled,
}: UserTableActionsProps) => {
  const { t } = useIntl();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          aria-haspopup="true"
          size="icon"
          variant="ghost"
          className="size-8"
          disabled={disabled}
        >
          <MoreHorizontal className="size-4" />
          <span className="sr-only">{t('navigation.openMenu')}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>{t('common.actions')}</DropdownMenuLabel>
        <DropdownMenuItem disabled={disabled} onClick={onEdit}>
          {t('common.edit')}
        </DropdownMenuItem>
        {!isInvite && !isArchived && (
          <DropdownMenuItem disabled={disabled} onClick={onArchive}>
            {t('users.archive')}
          </DropdownMenuItem>
        )}
        {!isInvite && isArchived && (
          <DropdownMenuItem disabled={disabled} onClick={onUnarchive}>
            {t('users.unarchive')}
          </DropdownMenuItem>
        )}
        {isInvite && (
          <DropdownMenuItem disabled={disabled} onClick={onResend}>
            {t('users.resend')}
          </DropdownMenuItem>
        )}
        {isInvite && (
          <DropdownMenuItem disabled={disabled} onClick={onDelete}>
            {t('common.delete')}
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
